import type { InterventionSectionTagColor } from "./intervention-section-tag.type";
import type { InterventionSectionObservation } from "@/modules/intervention/intervention-section";

export const getObservationColor = (
  observation: InterventionSectionObservation
): InterventionSectionTagColor => {
  const { is_validated, progress } = observation;
  const { filled, total } = progress;
  if (is_validated || filled === total) return "success";
  if (!filled) return "error";
  return "warning";
};
